import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Renders the Client Satisfaction monthly average-score trend line.
// points value: [{ label: "Jan 2026", score: 0.4 }, ...]
export default class extends Controller {
  static values = { points: Array }

  connect() {
    const labels = this.pointsValue.map((point) => point.label)
    const data = this.pointsValue.map((point) => point.score)

    this.chart = new Chart(this.element, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: "Average score",
            data,
            borderColor: "#2697D4",
            backgroundColor: "rgba(38, 151, 212, 0.1)",
            tension: 0.3,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { y: { suggestedMin: -1, suggestedMax: 1 } },
        plugins: { legend: { display: false } },
      },
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
